import { render, staticRenderFns } from "./ParametersManager.vue?vue&type=template&id=56a58b1a&scoped=true&"
import script from "./ParametersManager.vue?vue&type=script&lang=js&"
export * from "./ParametersManager.vue?vue&type=script&lang=js&"
import style0 from "./ParametersManager.vue?vue&type=style&index=0&id=56a58b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a58b1a",
  null
  
)

export default component.exports